<template>
  <div class="free-use">
    <el-dialog
      title=""
      append-to-body
      :visible.sync="dialogVisible1"
      :show-close="false"
      width="615px">
      <div class="h-600 text-[#333] px-60">
        <div class="f26 font-shs-medium text-center">君南软件免费试用</div>
        <div class="f14 mt-14 mb-18">为了给您提供更好的服务，希望您能抽出几分钟时间，将您想试用的软件和联系方式告诉我们，我们重视每一位用户，期待您的试用!</div>
        <div class="px-10">
          <div class="f20 font-shs-medium mb-10 relative before:content-['*'] before:absolute before:left-[-15px]">01 您申请的产品为（多选）：</div>
          <el-checkbox-group v-model="form.products" class="mb-16 flex-col">
            <el-checkbox class="mb-5" label="蓝晶数据治理平台"></el-checkbox>
            <el-checkbox class="mb-5" label="蓝晶数据中台"></el-checkbox>
            <el-checkbox class="mb-5" label="宏图BI"></el-checkbox>
            <el-checkbox class="mb-5" label="纬业低代码平台"></el-checkbox>
          </el-checkbox-group>
          <div class="f20 font-shs-medium mb-10 relative before:content-['*'] before:absolute before:left-[-15px]">02 您的姓名：</div>
          <el-input size="mini" class="mb-16" placeholder="请输入姓名" v-model="form.name"></el-input>
          <div class="f20 font-shs-medium mb-10 relative before:content-['*'] before:absolute before:left-[-15px]">03 您的手机号码：</div>
          <el-input size="mini" class="mb-16" placeholder="请输入手机号码" v-model="form.phone"></el-input>
          <div class="f20 font-shs-medium mb-10 relative before:content-['*'] before:absolute before:left-[-15px]">04 请填写您的企业名称：</div>
          <el-input size="mini" class="mb-16" placeholder="请输入企业名称" v-model="form.company_name"></el-input>
          <div class="f20 font-shs-medium mb-10 relative before:content-['*'] before:absolute before:left-[-15px]">05 请填写您的微信号码：</div>
          <el-input size="mini" class="mb-16" placeholder="请输入微信号码" v-model="form.wechat_code"></el-input>
        </div>
      </div>
      <div class="flex justify-center">
        <div class="btn mt-20" @click="submit">提交</div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      append-to-body
      top="35vh"
      :visible.sync="dialogVisible2"
      :show-close="false"
      width="615px">
      <div class="text-[#666] px-60 text-center">
        <div class="text-[#0099D2] mx-auto f32 mb-24 font-shs-medium">恭喜您，提交成功</div>
        <div class="f16 mb-24">你的申请已经成功提交，我们会尽快联系您!</div>
      </div>
      <div class="flex justify-center">
        <div class="btn mt-20" @click="dialogVisible2 = false;">返回首页</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'free-use',
  data () {
    return {
      dialogVisible1: false,
      dialogVisible2: false,
      form: {
        products: [],
        name: '',
        phone: '',
        company_name: '',
        wechat_code: '',
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible1 = true
      this.dialogVisible2 = false
    },
    submit() {
      if (!this.form.products.length) {
        this.$message({
          message: '请选择产品',
          type: 'warning'
        })
        return
      }
      if (!this.form.name) {
        this.$message({
          message: '请填写姓名',
          type: 'warning'
        })
        return
      }
      if (!this.form.phone) {
        this.$message({
          message: '请填写手机号码',
          type: 'warning'
        })
        return
      }
      if (!this.form.company_name) {
        this.$message({
          message: '请填写企业名称',
          type: 'warning'
        })
        return
      }
      if (!this.form.wechat_code) {
        this.$message({
          message: '请填写微信号码',
          type: 'warning'
        })
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '数据提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
        this.dialogVisible1 = false; 
        this.dialogVisible2 = true;
      }, 2000);
    }
  }
}
</script>
<style lang="scss" scoped>
.free-use {
}
::v-deep .el-dialog {
  border-radius: 16px;
}
</style>